<template>
  <div class="c-nodata" v-if="nodata">
    <Icon type="ios-filing-outline" size="92" color="#efefef" />
  </div>
  <div class="c-account-item" v-else>
    <div v-for="item in drops" :key="item.id" :class="itemClasses(item)" @click="$emit('on-child', { current: item.id, level })">
      <div v-if="item.children && item.children.length" class="c-item c-check-item">
        <Checkbox
          v-model="item.check"
          @on-change="ddddd(item, level)"
          :indeterminate="itemIndeterminate(item)"
          :disabled="item.disabled || disabled"
        />
        <span class="row-text">
          <span class="c-item-title">{{ item.name }} </span>
          <ins style="color: #ff9900" v-show="count(item.children)">({{ count(item.children) }})</ins></span
        >
        <Icon type="ios-arrow-forward" class="c-check-arrow" size="14" color="#c1c1c1" />
        <span class="c-item-checkbox c-cataract" @click="selectItem(item)"></span>
      </div>
      <div v-else class="c-item c-check-item">
        <Checkbox v-model="item.check" :disabled="item.disabled || disabled" />
        <span class="row-text">
          <span class="c-item-title">{{ item.name }}</span>
          <ins class="c-item-sub">{{ item.type | platform }}</ins>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { computeChild, mergeArray, trim, isEmpty } from '@/common/js/utils'
export default {
  name: 'groupItem',
  props: {
    value: {
      type: [String, Number]
    },
    data: {
      type: Array
    },
    level: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    keyword: {
      type: [String, Number]
    }
  },
  computed: {
    itemClasses() {
      return (item) => {
        const cls = ['m-account']
        item.id === this.value && cls.push('active')
        if (this.disabled || item.disabled) cls.push('m-disabled')
        return cls
      }
    },
    nodata() {
      const no = Boolean(this.drops.length)
      return !no
    },
    count() {
      return (child) => {
        const reducePlan = (ret, arr) => {
          ret.forEach((met) => {
            if (met.campaign && met.check) {
              const bool = arr.map((t) => t.id).includes(met.id)
              !bool && arr.push(met)
            }
            if (met.children && met.children.length) arr = mergeArray(arr, reducePlan(met.children, arr))
          })
          return arr
        }
        const c = reducePlan(child, [])
        return c.length
      }
    },
    drops() {
      const keyword = trim(this.keyword).toLowerCase()
      return this.data.filter((ret) => isEmpty(keyword) || ret.name.toLowerCase().includes(keyword))
    }
  },
  methods: {
    ddddd(item, level) {
      // console.log('item output: ', item)
      // console.log('level output: ', level)
      // this.$emit('on-child', { current: item.id, level })
    },
    selectItem(item) {
      if (item.disabled) return
      this.$emit('on-select', {
        check: !item.check,
        level: this.level,
        cat: item.id
      })
    },
    itemIndeterminate(child) {
      const hasChild = (meta) => {
        return meta.children.reduce((sum, item) => {
          let foundChilds = []
          if (item.check) sum.push(item)
          if (item.children) foundChilds = hasChild(item)
          return sum.concat(foundChilds)
        }, [])
      }
      const some = hasChild(child).length > 0
      const every = child.children && child.children.every((ret) => ret.check)
      return some && !every
    }
  },
  watch: {
    data: {
      handler(nVal, oVal) {
        computeChild(nVal, this)
      },
      deep: true
    }
  },
  mounted() {
    computeChild(this.data, this)
  },
  filters: {
    platform(cell) {
      if (cell === 'PROMOTED_OBJECT_TYPE_APP_ANDROID') return '安卓应用'
      else if (cell === 'PROMOTED_OBJECT_TYPE_APP_IOS') return 'iOS应用'
    }
  }
}
</script>
<style lang="scss" scoped>
.c-account-item {
  width: 100%;
  position: relative;

  .m-account {
    padding: 8px 12px;
    display: flex;

    &:hover {
      background-color: #f8f8f8;
    }

    &.active {
      color: #598fe6;
      background-color: #f8f8f8;

      .c-check-arrow {
        color: #598fe6 !important;
      }
    }

    .c-item-checkbox {
      width: 24px;
      height: 100%;
    }
  }

  .c-cataract {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    cursor: pointer;
  }

  .m-disabled {
    color: #ccc;

    &.active {
      color: #a5bada;

      .c-check-arrow {
        color: #a5bada !important;
      }
    }

    .c-cataract {
      visibility: hidden;
    }
  }

  .c-item {
    width: 100%;
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    > span {
      width: calc(100% - 38px);
      font-size: 0;

      &.row-text {
        margin-left: 10px;
      }
    }

    .ivu-checkbox-wrapper {
      margin-right: 0;
    }

    .c-item-title {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      line-height: 1.5;
      display: inline-block;
      width: 100%;
      font-size: 12px;
    }

    .c-item-sub {
      color: #bbb;
      font-size: 12px;
      line-height: 1;
    }
  }

  ::v-deep .ivu-checkbox-indeterminate {
    .ivu-checkbox-inner {
      background-color: #6fb3fb;
      border-color: #6fb3fb;
    }
  }
}

.c-nodata {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .ivu-icon {
    display: inline-block;
  }
}
</style>
